import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { 
  exportSellersHistoricToCSV, 
  generateSellersHistoricFilename 
} from "@/utils/sellersHistoricExport";

interface SellerHistoricData {
  seller_id: number;
  seller: string;
  total_vendido: string;
}

interface HistoricResponse {
  start_date: string;
  end_date: string;
  sellers: SellerHistoricData[];
  total_geral: string;
}

interface SellerHistoricTableProps {
  dataApi: HistoricResponse | null;
}

export const SellersHistoricTable = ({
  dataApi,
}: SellerHistoricTableProps) => {
  const handleExportCSV = () => {
    if (dataApi && dataApi.sellers.length > 0) {
      const filename = generateSellersHistoricFilename(dataApi);
      exportSellersHistoricToCSV(dataApi, filename);
    }
  };

  return (
    <>
      {dataApi && dataApi.sellers.length > 0 && (
        <div className="flex justify-end mb-4">
          <Button
            onClick={handleExportCSV}
            variant="outline"
            className="flex items-center gap-2"
          >
            <Download className="h-4 w-4" />
            Exportar Excel
          </Button>
        </div>
      )}
      
      <Table className="bg-zinc-50 rounded dark:bg-[#2c2c2c]">
        <TableHeader>
          <TableRow>
            <TableHead>Nome do Vendedor</TableHead>
            <TableHead className="text-center">Total de Vendas</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {dataApi?.sellers?.map((seller) => (
            <TableRow key={seller.seller_id}>
              <TableCell className="font-medium">{seller.seller}</TableCell>
              <TableCell className="text-center">
                R$ {seller.total_vendido}
              </TableCell>
            </TableRow>
          ))}
          {(!dataApi?.sellers || dataApi.sellers.length === 0) && (
            <TableRow>
              <TableCell colSpan={2} className="text-center py-8">
                <p className="text-gray-500">Nenhum vendedor encontrado.</p>
              </TableCell>
            </TableRow>
          )}
          {dataApi?.total_geral && (
            <TableRow className="bg-gray-100 dark:bg-gray-700 font-semibold">
              <TableCell className="font-bold">Total Geral</TableCell>
              <TableCell className="text-center font-bold">
                R$ {dataApi.total_geral}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      
      {dataApi?.sellers && dataApi.sellers.length > 0 && (
        <div className="mt-4 text-center">
          <span className="text-sm text-gray-600 dark:text-gray-300">
            Total de {dataApi.sellers.length} vendedores encontrados
          </span>
        </div>
      )}
    </>
  );
};